import React, { useState } from 'react';
import { Row } from '../../grid/Row/Row';
import { Input } from '../Input/Input';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { TextParam } from '../../types/TextParam';

type FormColorChooserProps = {
  param: TextParam<any>;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function isHexColor(hex?: string) {
  const colorCode = hex?.includes('#') ? hex.split('#')[1] : hex;
  return (colorCode?.length === 3 || colorCode?.length === 6) && !Number.isNaN(Number(`0x${colorCode}`));
}

export function ColorChooser({ label, param, onChange }: FormColorChooserProps) {
  const { t } = useSonTranslation('FormColorChooser');

  const [currentColor, setCurrentColor] = useState<string | undefined>(param?.value);

  return (
    <Row>
      <div className="color-chooser__container">
        <div className="color-chooser__input">
          <Input
            label={label}
            helpText={t('helpText')}
            param={param}
            onChange={e => {
              setCurrentColor(e.target.value);
              if (e.target.validity.patternMismatch) {
                e.target.setCustomValidity(t('errorMessage'));
              } else {
                e.target.setCustomValidity('');
              }
              onChange?.(e);
            }}
          />
        </div>
        <div className="color-chooser__preview" aria-hidden="true">
          <p className="color-chooser__preview-container">
            <dfn className="color-chooser__label font-bold-15-19">{t('preview')}</dfn>
            <span
              style={{ backgroundColor: isHexColor(currentColor) ? currentColor : undefined }}
              className="color-chooser__color"
              id="theme-color-preview" // QF-Test ID. Don't touch!
            >
              &nbsp;
            </span>
          </p>
        </div>
      </div>
    </Row>
  );
}
